/**
 * Binds all of an object's methods to the object so references to "this" work as expected
 * @param obj The object to bind ("this" in the class's constructor)
 */
export const bindMethods = (obj) => {
    Object.getOwnPropertyNames(Object.getPrototypeOf(obj)).forEach((propName) => {
        if (propName !== 'constructor' && typeof obj[propName] === 'function') {
            obj[propName] = obj[propName].bind(obj);
        }
    });
};
